import { Card, CardContent } from '@/components/ui/card';

export function DocsPage() {
  return (
    <section className="container max-w-3xl py-16">
      <h1 className="text-4xl font-bold tracking-tight">Docs</h1>
      <p className="mt-3 text-muted-foreground">
        Short how-tos and FAQs. We'll flesh this out as customer questions show up.
      </p>

      <div className="mt-10 space-y-4">
        <Doc title="Getting started">
          Your manager invites you by email. Open the invite on the same phone you'll use to shoot
          cars — the link sets your password and logs you in.
        </Doc>
        <Doc title="Capture flow">
          Tap <b>New Car</b>, enter the VIN (we decode the year/make/model for you), and step through
          the 20 guided shots. The guide overlay shows where to stand for each angle.
        </Doc>
        <Doc title="Backgrounds and overlays">
          Managers upload approved backgrounds and transparent PNG overlays in Settings →
          Backgrounds / Overlays. Anyone on the dealership can apply them to any car later — so the
          same photos can be re-themed for a holiday sale without re-shooting.
        </Doc>
        <Doc title="Export">
          On the car detail page, tap <b>Export</b>. You get a ZIP with originals, cutouts, and the
          composited final — ready for your DMS or a social post.
        </Doc>
        <Doc title="100-car cap">
          Each dealership keeps the 100 most recent cars live. When you start the 101st, BGSwap
          asks you to archive or export the oldest. No surprises, no data silently dropped.
        </Doc>
      </div>
    </section>
  );
}

function Doc({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <Card>
      <CardContent className="py-6">
        <div className="font-semibold">{title}</div>
        <div className="mt-2 text-sm text-muted-foreground">{children}</div>
      </CardContent>
    </Card>
  );
}
